import * as angular from 'angular';
import NavControllerName from './nav.controller';
import navTemplate from "./nav.tpl.html";

/**
 * @module *.directive.nav
 * @file directive for the apps navigation
 */
export default angular.module('aps.directive.nav', [NavControllerName])
  .directive('apsNav', navDef)
  .name;

/**
 * @method navDef
 * @description directive definition
 * @returns {{
 *  restrict: string, templateUrl: string,
 *  replace: boolean, controller: string, controllerAs: string,
 *  bindToController: boolean
 * }}
 */
function navDef() {
  return {
    restrict: 'E',
    template: navTemplate,
    replace: false,
    controller: 'NavCtrl',
    controllerAs: 'vm',
    bindToController: true
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/layout/nav/nav.directive.ts